const featuresData = [
    {  
        id:1,
    iconName :"boxes",
    title: "Inventory Tracking",
    desc:"Real-time inventory mangaement with low stock alert system."
},
{  
        id:1,
    iconName :"users",
    title: "Customer Management",
    desc:"Track customer purchases, preferences, and history to build better relationships."
},
{  
        id:1,
    iconName :"chart-line",
    title: "Sales Analytics",
    desc:"Beautiful dashboards and reports to understand your business performance."
},
]
export default featuresData;
